<template>
  <div class="filtered-courses">
    <div class="filtered-courses__wrapper">
      <div class="filtered-courses__heading">
        <div
          v-for="(choice, i) in filters"
          :key="i"
          @click="currentChoice = choice"
          :class="
            choice === currentChoice
              ? 'filtered-courses__filter filtered-courses__filter--selected'
              : 'filtered-courses__filter'
          "
        >
          {{ choice }}
        </div>
      </div>
      <FilteredCourses
        v-if="currentChoice === 'Popular'"
        :courses="popularCourses.slice(0, 4)"
        :categoryName="category.name"
      />
      <FilteredCourses
        v-if="currentChoice === 'New Courses'"
        :courses="categoryNewCourses.slice(0, 4)"
        :categoryName="category.name"
      />
      <div
        v-show="currentChoice === 'Learning Paths'"
        class="filtered-courses__learning-paths"
      >
        <LearningPathsCarousel
          :currentCategory="category.name"
          @resultsFound="handlePlaylistResults"
        ></LearningPathsCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import FilteredCourses from './FilteredCourses.vue'
import LearningPathsCarousel from './LearningPathsCarousel.vue'

export default {
  name: 'LearningAreaFilteredCourses',
  data() {
    return {
      currentChoice: 'Popular',
      playlistResultsFound: 0,
    }
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    popularCourses: {
      type: Array,
    },
    categoryNewCourses: {
      type: Array,
    },
  },
  watch: {
    playlistResultsFound(num) {
      if (num > 0) {
        this.currentChoice = 'Learning Paths'
      }
    },
  },
  computed: {
    filters() {
      const filters = []
      if (this.playlistResultsFound !== 0) {
        filters.push('Learning Paths')
      }
      if (this.popularCourses && this.popularCourses.length > 0) {
        filters.push('Popular')
      }
      if (this.categoryNewCourses && this.categoryNewCourses.length > 0) {
        filters.push('New Courses')
      }
      return filters
    },
  },
  methods: {
    handlePlaylistResults(length) {
      this.playlistResultsFound = length
    },
  },
  components: {
    FilteredCourses,
    LearningPathsCarousel,
  },
}
</script>

<style lang="scss" scoped>
.filtered-courses {
  position: relative;
  min-height: 305px;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  &__heading {
    display: flex;
    flex-wrap: wrap;
    width: auto;
    margin-bottom: 20px;
  }
  &__filter {
    color: var(--white);
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 700;
    transition: 0.5s all ease;
    margin: 0 25px 5px 0;
    max-height: 25px;
    white-space: nowrap;
    &:hover {
      cursor: pointer;
      color: var(--orange);
    }
    &--selected {
      border-bottom: 1px solid #ef7d22;
    }
  }
  &__learning-paths {
    z-index: 2;
    min-width: 100%;
    min-height: 315px;
    margin-bottom: 2.5%;
  }
}
</style>
